export default "__VITE_ASSET__e9f769df__"